import i18n from "config/i18next";

i18n.addResources("es", "tableTemplates", {
  region: "Región",
  workzone: "Zona de operación",
  shift: "Horario",
  frecuency: "Frecuencia",
  updatedAt: "Actualización",
});
